const {h, render, Component} = require('preact');

class StaticButton extends Component {
  constructor(props) {
    super(props);
  }

  isValidString(str){
    return (str!=undefined && str && (str.trim() !== ''))
  }

  getButton() {
    let liveChatSetting = this.props.liveChatSetting
    let liveChatConfig = liveChatSetting.liveChat
    let tags = liveChatSetting.tags
    let liveChatContainer = document.getElementById(liveChatSetting.liveChatContainerId);
    let firstName = this.isValidString(liveChatSetting.firstName)? liveChatSetting.firstName: ""
    let lastName = this.isValidString(liveChatSetting.lastName)? liveChatSetting.lastName: ""
    let userEmail = this.isValidString(liveChatSetting.userEmail)? liveChatSetting.userEmail: ""
    let question = liveChatSetting.initialQuestion + (liveChatSetting.guestQuestion? liveChatSetting.guestQuestion: "")
    if(liveChatContainer) {
      window._bcvma = window._bcvma || [];
      _bcvma.push(["setAccountID", liveChatConfig.accountID]);
      _bcvma.push(["setParameter", "VisitName", firstName]);
      _bcvma.push(["setParameter", "LastName", lastName]);
      _bcvma.push(["setParameter", "VisitEmail", userEmail]);
      _bcvma.push(["setParameter", "InitialQuestion", question]);
      _bcvma.push(["setParameter", "WebsiteID", liveChatConfig.websiteDefID]);
      _bcvma.push(["setParameter", "CustomUrl", ""]);
      _bcvma.push(["setParameter", "WindowParameters", "vn=" + encodeURIComponent(firstName) + "&ln=" + encodeURIComponent(lastName) + "&ve=" + encodeURIComponent(userEmail) + "&iq=" + encodeURIComponent(question) + "&customField_tags="+encodeURIComponent(tags)]);
      _bcvma.push(["addFloat", {type: "chat", id: liveChatConfig.buttonId}]);

      _bcvma.push(["pageViewed"]);
      var bcLoad = function(){
        if(window.bcLoaded) return; window.bcLoaded = true;
        var vms = document.createElement("script"); vms.type = "text/javascript"; vms.async = true;
        vms.src = ('https:'==document.location.protocol?'https://':'http://') + "vmss.boldchat.com/aid/" + liveChatConfig.accountID + "/bc.vms4/vms.js";
        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(vms, s);
      };
      if(window.pageViewer && pageViewer.load) pageViewer.load();
      else if(document.readyState=="complete") bcLoad();
      else if(window.addEventListener) window.addEventListener('load', bcLoad, false);
      else window.attachEvent('onload', bcLoad);
    }
  }

  render() {
    return (
      <div style="text-align: center; white-space: nowrap;">
        <script type="text/javascript">
          {this.getButton()}
        </script>
      </div>
    )
  }
}

module.exports = StaticButton
